import React from 'react'
import ShapesSection from './ShapesSection'

const BasicShapesSection = ({items, pagination, onAddShape, title = 'Basic Shapes', emptyComponent}) => {
    return (
        <ShapesSection
            title={title}
            items={items}
            pagination={pagination}
            emptyComponent={emptyComponent}
            renderItem={({shapeType, data, rawWidth, rawHeight, label}) => (
                <button
                    key={shapeType}
                    type="button"
                    className="SidebarPanel__ShapeThumb"
                    onClick={() => onAddShape(shapeType)}
                    aria-label={label}
                    title={label}
                >
                    <svg
                        viewBox={`0 0 ${rawWidth} ${rawHeight}`}
                        width="60%"
                        height="60%"
                        aria-hidden="true"
                        fill="currentColor"
                    >
                        <path d={data} />
                    </svg>
                </button>
            )}
        />
    )
}

export default BasicShapesSection
